.dataRangeControlsContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
}